export const MEDIA_TYPES = {
    IMAGE: 1,
    VIDEO: 2,
    FILE: 3,
    TEXT: 4,
};